import { createBrowserHistory } from 'history';
const history = createBrowserHistory();
export default history;



// WEBPACK FOOTER //
// ./src/common/history.js